<!--
 * @Author: cryi.liu
 * @Date: 2020-06-13 15:42:11
 * @LastEditTime: 2020-06-16 11:18:28
 * @Description: 提交操作栏
-->
<template>
  <div class="submit-action-bar">
    <pss-button text="提交" @on-click="submitExamApprovalHandler" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SubmitActionBar',
  props: {
    examId: { type: [Number, String], required: true },
  },
  methods: {
    /**
     * 提交考试审批处理函数
     */
    submitExamApprovalHandler() {
      if (window.confirm('确认提交审批？')) {
        this.requestExamApprovalAndSetting();
      }
    },
    /**
     * 请求考试审批并设置
     */
    requestExamApprovalAndSetting() {
      this.requestExamApproval()
        .then(() => {
          alert('提交审批成功');

          this.$emit('change-status', '');
        })
        .catch(() => {
          alert('提交审批错误');
        });
    },
    /**
     * 请求考试审批
     */
    requestExamApproval() {
      return new Promise(async (resolve, reject) => {
        const result = await axios.post(`/mvc/exam/setting/submit/${this.examId}`);

        if (result.data) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.submit-action-bar {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
